const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum)

export const fitTooltipHorizontally = ({
    preferredLeft,
    tooltipWidth,
    anchorCenter,
    viewportLeft = 0,
    viewportWidth,
    viewportMargin = 16,
    arrowMargin = 12,
}) => {
    const minimumLeft = viewportLeft + viewportMargin
    const maximumLeft = Math.max(minimumLeft, viewportLeft + viewportWidth - viewportMargin - tooltipWidth)
    const left = clamp(preferredLeft, minimumLeft, maximumLeft)
    const maximumArrowLeft = Math.max(arrowMargin, tooltipWidth - arrowMargin)

    return {
        left,
        arrowLeft: clamp(anchorCenter - left, arrowMargin, maximumArrowLeft),
    }
}

export const resolveTooltipPlacement = ({
    preferredPlacement,
    tooltipHeight,
    anchorTop,
    anchorBottom,
    viewportTop = 0,
    viewportHeight,
    viewportMargin = 16,
    tooltipGap = 12,
}) => {
    const viewportBottom = viewportTop + viewportHeight
    const spaceAbove = anchorTop - viewportTop - viewportMargin - tooltipGap
    const spaceBelow = viewportBottom - viewportMargin - anchorBottom - tooltipGap
    const topFits = tooltipHeight <= spaceAbove
    const bottomFits = tooltipHeight <= spaceBelow

    if (preferredPlacement === 'bottom') {
        if (bottomFits || (!topFits && spaceBelow >= spaceAbove)) return 'bottom'

        return 'top'
    }

    if (topFits || (!bottomFits && spaceAbove >= spaceBelow)) return 'top'

    return 'bottom'
}
